import { Box, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import Meta from "./../../Meta/Meta";
import CoursesGrid from "./CoursesGrid";
import StudentMobileNav from "./StudentMobileNav";
import StudentNavBar from "./StudentNavBar";
import StudentSideBar from "./StudentSideBar";

export const StudentDashboardLayout = ({ children, route }) => {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box sx={{ position: "relative" }}>
      {isMobile ? (
        <StudentMobileNav />
      ) : (
        <>
          <StudentNavBar />
          <StudentSideBar />
        </>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          ml: isMobile ? 0 : isArabic ? "0" : "var(--sidebar-width)",
          mr: isMobile ? 0 : isArabic ? "var(--sidebar-width)" : "0",
        }}
      >
        <Outlet />
        {children}
      </Box>
    </Box>
  );
};

const StudentDashboard = () => {
  return (
    <StudentDashboardLayout>
      <Meta
        title="ALGermanist - My Dashboard "
        description="View your enrolled courses, track your progress, and check your placement test status."
        keywords="student dashboard, courses, progress, placement test"
      />
      <CoursesGrid />
    </StudentDashboardLayout>
  );
};

export default StudentDashboard;
